<template>
    <div class="container-fluid p-0">
        <div class="row">
            <form method="post" ref="form" :data-url="brand_privacy">
                <div class="col-12">
                    <div class="form-group">
                        <app-input
                            type="checkbox"
                            v-model="trackingSettings"
                            :list="trackingOptions"
                            :error-message="$errorMessage(errors, 'context')"
                        />
                    </div>

                    <div class="form-group mb-0">
                        <app-submit-button :loading="loading" @click="saveTrackingSettings" />
                    </div>
                </div>
            </form>
        </div>
        <app-pre-loader v-if="is_loading"/>
    </div>
</template>

<script>
    import FormHelperMixins from "../../../../../Mixins/Global/FormHelperMixins";
    import {brand_privacy} from '../../../../../config/apiUrl'

    export default {
        mixins: [FormHelperMixins],
        name: "BrandTrackingSettings",
        data() {
            return {
                is_loading: true,
                trackingSettings: [],
                trackingOptions: [
                    {
                        id: 'track_open_in_campaigns',
                        value: this.$t('track_campaigns_message', {
                            'action': this.$t('opens').toLowerCase(),
                            'subject': this.$t('campaigns').toLowerCase()
                        })
                    },
                    {
                        id: 'track_clicks_in_your_campaigns',
                        value: this.$t('track_campaigns_message', {
                            'action': this.$t('clicks').toLowerCase(),
                            'subject': this.$t('campaigns').toLowerCase()
                        })
                    }
                ],
                brand_privacy
            }
        },
        mounted() {
            this.axiosGet(brand_privacy).then(res => {
                this.trackingSettings = Object.keys(res.data);
            }).finally(() => {
                this.is_loading = false;
            });
        },
        methods: {
            saveTrackingSettings() {
                this.loading = false;
                this.message = '';
                this.trackingSettings.context = 'privacy';
                this.save(this.trackingSettings);
            },
            afterSuccess({data}) {
                this.scrollToTop(false);
                this.toastAndReload(data.message);
            }
        }
    }
</script>
